Object.defineProperty(exports,"__esModule",{value:true});function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default={
isNonEmptyArray:function isNonEmptyArray(collection){
return Array.isArray(collection)&&collection.length>0;
},

containsStrings:function containsStrings(collection){
return Array.isArray(collection)&&collection.some(function(value){return typeof value==="string";});
},

containsDates:function containsDates(collection){
return Array.isArray(collection)&&collection.some(function(value){return value instanceof Date;});
},

containsOnlyStrings:function containsOnlyStrings(collection){
return this.isNonEmptyArray(collection)&&
collection.every(function(value){return typeof value==="string";});
},

isArrayOfArrays:function isArrayOfArrays(collection){
return this.isNonEmptyArray(collection)&&collection.every(Array.isArray);
},

removeUndefined:function removeUndefined(arr){
return arr.filter(function(el){return el!==undefined;});
},

getMaxValue:function getMaxValue(arr){for(var _len=arguments.length,values=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){values[_key-1]=arguments[_key];}
var array=arr.concat(values);
return this.containsDates(array)?
new Date(Math.max.apply(Math,_toConsumableArray(array))):
Math.max.apply(Math,_toConsumableArray(array));
},

getMinValue:function getMinValue(arr){for(var _len2=arguments.length,values=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){values[_key2-1]=arguments[_key2];}
var array=arr.concat(values);
return this.containsDates(array)?
new Date(Math.min.apply(Math,_toConsumableArray(array))):
Math.min.apply(Math,_toConsumableArray(array));
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/collection.js
// module id = 131
// module chunks = 0